import UniversalChat from "../../components/common/UniversalChat";
import { usePermissions } from "../../hooks/usePermissions";
import { useAuth } from "../../context/AuthContext";

function PMChatPg() {
  const { user } = useAuth();
  const { canWrite } = usePermissions();
  return <UniversalChat currentUserId={user?.userId} canWrite={canWrite('chat')} allowGroupCreate />;
}

export default PMChatPg;
